import { InlineNotification, Loading } from '@carbon/react';
import { ActivityLogFooter } from './activity-log-footer';
import type { ActivityFeed } from './hooks';
import { PartyAuditLog } from './party-audit-log';
import style from './activity-log.module.scss';

interface ActivityLogProps {
  activity: ActivityFeed;
  emptyMessage: string;
}

/**
 * An activity log with its loading, failure and empty states, and the loader for older pages.
 *
 * @param {ActivityLogProps} props - The feed, and what to say when it has no activity.
 * @return {JSX.Element} The log, or the state that stands in for it.
 */
export function ActivityLog({ activity, emptyMessage }: ActivityLogProps) {
  if (activity.loading) {
    return (
      <Loading withOverlay={false} description="Loading activity log…" small />
    );
  }
  if (activity.error) {
    return (
      <InlineNotification
        kind="error"
        role="alert"
        lowContrast
        title="Error"
        subtitle={activity.error}
        hideCloseButton
      />
    );
  }
  if (activity.rows.length === 0) {
    return <p className={style.empty}>{emptyMessage}</p>;
  }
  return (
    <>
      <PartyAuditLog rows={activity.rows} totalCount={activity.totalCount} />
      <ActivityLogFooter activity={activity} />
    </>
  );
}
